module.exports = __webpack_public_path__ + "img/person_add.a29134c6.svg";